import React, { Component } from "react";
import NumberFormat from "react-number-format";
import InputMask from "../modules/popup/InputMask";
import TimeDD from "../modules/popup/TimeDD";
import TimeMinuteDD from "../modules/popup/TimeMinuteDD";

class SimpleInput extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      label,
      mandatory,
      readOnly,
      box,
      type,
      value,
      onChange,
      errorMessage,
      showErrorWithoutMandatory,
      ...rest
    } = this.props;
    return (
      <div
        className={`margin-bottom-20px ${
          this.props.containerclassname ? this.props.containerclassname : ""
        }`}
      >
        <div className="margin-5px">
          <div className="txt-site txt-11 txt-main txt-bold">
            <h4>
              {label} {mandatory && <span style={{ color: "red" }}>*</span>}
            </h4>
          </div>
        </div>

        {box === "number" ? (
          <NumberFormat
            {...rest}
            thousandSeparator="."
            decimalSeparator=","
            value={value}
            disabled={readOnly}
            style={{
              ...(rest.style || {}),
              backgroundColor: readOnly ? "#E6E6E6" : undefined,
            }}
            type="text"
            className="txt txt-sekunder-color"
          />
        ) : null}

        {box === "mask" ? <InputMask {...rest} onChange={onChange} value={value} /> : null}

        {box === "time" ? <TimeDD {...rest} /> : null}

        {box === "timePicker" ? (
          <TimeMinuteDD
            {...rest}
            time={value}     
            onChange={onChange}
          />
        ) : null}

        {box === "alphaNumericDot" ? (
          <input
            {...rest}
            style={{ backgroundColor: readOnly && "#E6E6E6" }}
            type={type ? type : "text"}
            className="txt txt-sekunder-color"
            value={value ?? ""}
            disabled={readOnly}
            onChange={(e) => {
              const re = /^[a-zA-Z0-9\.\s]*$/;
              if (e.target.value === "" || re.test(e.target.value)) {
                e.target.value = e.target.value.toUpperCase();
                onChange(e);
              }
            }}
          />
        ) : null}

        {box === "alphaNumericDash" ? (
          <input
            {...rest}
            style={{ backgroundColor: readOnly && "#E6E6E6" }}
            type={type ? type : "text"}
            className="txt txt-sekunder-color"
            value={value ?? ""}
            disabled={readOnly}
            onChange={(e) => {
              const re = /^[a-zA-Z0-9\s-]*$/;
              if (e.target.value === "" || re.test(e.target.value)) {
                e.target.value = e.target.value.toUpperCase();
                onChange(e);
              }
            }}
          />
        ) : null}

        {box === "alphabet" ? (
          <input
            {...rest}
            style={{ backgroundColor: readOnly && "#E6E6E6" }}
            type={type ? type : "text"}
            className="txt txt-sekunder-color"
            value={value ?? ""}
            disabled={readOnly}
            onChange={(e) => {
              const re = /^[^0-9!-\/:-@\[-`{-~]*$/;
              if (e.target.value === "" || re.test(e.target.value)) {
                e.target.value = e.target.value.toUpperCase();
                onChange(e);
              }
            }}
          />
        ) : null}

        {box === "onlyNumber" ? (
          <input
            {...rest}
            style={{ backgroundColor: readOnly && "#E6E6E6" }}
            type={type ? type : "text"}
            className="txt txt-sekunder-color"
            value={value ?? ""}
            disabled={readOnly}
            onChange={(e) => {
              const re = /^[^a-zA-Z\s!-\/:-@\[-`{-~]*$/;
              if (e.target.value === "" || re.test(e.target.value)) {
                onChange(e);
              }
            }}
          />
        ) : null}

        {box === "onlyNumberNoDecimal" ? (
          <input
            {...rest}
            style={{ backgroundColor: readOnly && "#E6E6E6" }}
            type={type ? type : "text"}
            className="txt txt-sekunder-color"
            value={value ?? ""}
            disabled={readOnly}
            onChange={(e) => {
              const re = /^[0-9]*$/;
              if (e.target.value === "" || re.test(e.target.value)) {
                onChange(e);
              }
            }}
          />
        ) : null}

        {box === "code" ? (
          <input
            {...rest}
            style={{ backgroundColor: readOnly && "#E6E6E6" }}
            type={type ? type : "text"}
            className="txt txt-sekunder-color"
            value={value ?? ""}
            disabled={readOnly}
            onChange={(e) => {
              const re = /^[^\s]*$/;
              if (e.target.value === "" || re.test(e.target.value)) {
                e.target.value = e.target.value.toUpperCase();
                onChange(e);
              }
            }}
          />
        ) : null}

        {box === "lowerCase" ? (
          <input
            {...rest}
            style={{ backgroundColor: readOnly && "#E6E6E6" }}
            type={type ? type : "text"}
            className="txt txt-sekunder-color"
            value={value ?? ""}
            disabled={readOnly}
            onChange={(e) => {
              e.target.value = e.target.value.toLowerCase();
              onChange(e);
            }}
          />
        ) : null}

        {box === "alphaNumeric" ? (
          <input
            {...rest}
            style={{ backgroundColor: readOnly && "#E6E6E6" }}
            type={type ? type : "text"}
            className="txt txt-sekunder-color"
            value={value ?? ""}
            disabled={readOnly}
            onChange={(e) => {
              const re = /^[a-zA-Z0-9-]*$/;
              if (e.target.value === "" || re.test(e.target.value)) {
                e.target.value = e.target.value.toUpperCase();
                onChange(e);
              }
            }}
          />
        ) : null}

        {box === "upperCase" ? (
          <input
            {...rest}
            style={{ backgroundColor: readOnly && "#E6E6E6" }}
            type={type ? type : "text"}
            className="txt txt-sekunder-color"
            disabled={readOnly}
            value={value ?? ""}
            onChange={(e) => {
              e.target.value = e.target.value.toUpperCase();
              onChange(e);
            }}
          />
        ) : null}

        {box === "alphaNumericStrict" ? (
          <input
            {...rest}
            style={{ backgroundColor: readOnly && "#E6E6E6" }}
            type={type ? type : "text"}
            className="txt txt-sekunder-color"
            value={value ?? ""}
            disabled={readOnly}
            // placeholder="Contoh: B 1234 CD"
            onChange={(e) => {
              const re = /^[A-Za-z0-9\s]*$/;
              if (e.target.value === "" || re.test(e.target.value)) {
                e.target.value = e.target.value.toUpperCase();
                onChange(e);
              }
            }}
          />
        ) : null}

        {box === undefined ? (
          <input
            {...rest}
            style={{
              ...(rest.style || {}),
              backgroundColor: readOnly ? "#E6E6E6" : undefined,
            }}
            type={type ? type : "text"}
            className="txt txt-sekunder-color"
            disabled={readOnly}
            value={value ?? ""}
            onChange={onChange}
          />
        ) : null}
        {mandatory && errorMessage && (
          <p className="txt-site txt-11 color-red margin-top-5px">
            {errorMessage}
          </p>
        )}
        {showErrorWithoutMandatory && errorMessage && (
          <p className="txt-site txt-11 color-red margin-top-5px">
            {errorMessage}
          </p>
        )}
      </div>
    );
  }
}

export default SimpleInput;
